import React, { forwardRef } from 'react';
import cn from 'classnames';

import { useAppearFromBelow } from '../util/hooks';

import RefraccionesIcon from './icons/Refracciones';

import * as styles from './Card.module.css';

const Card = forwardRef(
  (
    {
      children,
      title,
      className,
      innerClassName,
      animate,
      onClick = () => {},
      tag = 'div',
      footer,
      id,
      ...rest
    },
    innerRef
  ) => {
    const Tag = tag;

    const [ref, appeared] = useAppearFromBelow();

    return (
      <Tag
        onClick={onClick}
        className={cn(styles.root, className, {
          [styles.animated]: animate,
          [styles.appeared]: animate && appeared
        })}
        {...rest}
        ref={ref}
      >
        {title && (
          <header className={cn(styles.header)}>
            <h2>
              <a href={`#${id}`} className={cn(styles.title)}>
                <RefraccionesIcon
                  aria-hidden
                  className={cn(styles.titleIcon)}
                />
                {title}
              </a>
            </h2>
          </header>
        )}

        <div ref={innerRef} className={cn(styles.inner, innerClassName)}>
          {children}
        </div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </Tag>
    );
  }
);

export default Card;
